import { render, staticRenderFns } from "./ImprovementIdeaView.vue?vue&type=template&id=1f2fb1b0"
import script from "./ImprovementIdeaView.vue?vue&type=script&lang=js"
export * from "./ImprovementIdeaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports